import React from "react";
import MetaTags from "react-meta-tags";
import { Col, Row } from "antd";
import "./index.css";
import Program from "./Program";


function AboutUsProgram() {
  
  return (
    <React.Fragment>
      {/* <Layout> */}
      <div>
        <MetaTags>
          <title> About the Program | PMT</title>
        </MetaTags>

        <Row className="mb-5">
          {/* <Col span={24}>
            <div className="about_program_image"></div>
          </Col> */}
          <Col span={24} >
            <div >
            <Program />
            </div>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
}

export default AboutUsProgram;
